import { ControlSelectorProps } from "./ControlSelector.types"
import "./ControlSelector.css"

const ControlSelector = (props: ControlSelectorProps) => {

  const { options, selected, onSelect } = props

  return (
    <div className="control-selector">
      {options.map((option, i) => (
        <div 
          key={i}
          className={`control-selector-option ${selected === i ? "control-selector-option-selected" : ""}`}
          onClick={() => onSelect(i)}
        >
          {option}
        </div>
      ))}
    </div>
  )
}

export default ControlSelector